import { usePlatformApi } from '@wix/yoshi-flow-bm';
import { OnBeforeUnload } from '@wix/bex-core';

export function usePlatformApiCompat(): { onBeforeUnload?: OnBeforeUnload } {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return usePlatformApi() ?? {};
  } catch (e) {
    console.error(e);
    return {};
  }
}
